import NotificationAlert from 'componentes/generic/Notification.js';
import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import React, { useState } from 'react';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
const URI = ApiEndpoint + 'account/';

const EditPassword = ({ closeModal }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMesagge, setErrorMesagge] = useState(null);

  const {
    register,
    handleSubmit,

    formState: { errors }
  } = useForm();

  const onSubmit = data => {
    console.log(data);

    if (data.password != data.confirmPassword) {
      setErrorMesagge('Las contraseñas no coinciden');
      setShowErrorMessage(true);
      return;
    }
    var formatregex =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{6,16}$/;
    if (!formatregex.test(data.password)) {
      setErrorMesagge('La contraseña no contiene un formato valido');
      setShowErrorMessage(true);
      return;
    }

    httpClient(
      'put',
      URI + 'setpass/',
      {
        password: data.password
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  return (
    <>
      <Card style={{ width: '100%' }}>
        <Card.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <>
              <Row>
                <Col>
                  <Form.Group className="mb-4">
                    <Form.Label>Contraseña</Form.Label>
                    <h5
                      style={{
                        marginTop: '0px',
                        marginBottom: '10px',
                        borderRadius: '5px',
                        padding: '5px',
                        background: '#6d757d',
                        color: '#fff',
                        width: 'fit-content',
                        fontWeight: '400',
                        fontSize: '12px'
                      }}
                    >
                      La contraseña debe tener una longitud minima de 6
                      caracteres y al menos debe contener al menos un numero,
                      una letra minuscula, una letra mayuscula, y un caracter
                      especial
                    </h5>
                    <FormControl
                      {...register('password')}
                      type="password"
                      defaultValue={''}
                      isInvalid={!!errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-4">
                    <Form.Label>Confirmar Contraseña</Form.Label>
                    <FormControl
                      {...register('confirmPassword')}
                      type="password"
                      defaultValue={''}
                      isInvalid={!!errors.confirmPassword}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.confirmPassword?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </>

            <Row>
              <Col>
                <Button type="submit" color="primary" size="sm">
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
      <NotificationAlert
        message={errorMesagge}
        showNotification={showErrorMessage}
        setShowNotification={setShowErrorMessage}
      />
    </>
  );
};
EditPassword.propTypes = {
  closeModal: PropTypes.func
};
export default EditPassword;
